module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "caption-text",
    domProps: {
      "innerHTML": _vm._s(_vm.noSpaceContent)
    }
  }), _vm._v(" "), _vm._l((_vm.links), function(link) {
    return _c('span', {
      staticClass: "link-container"
    }, [(link.link_type === "External") ? _c('span', [_vm._v("("), _c('a', {
      attrs: {
        "href": link.external_link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.link_title))]), _vm._v(")")]) : (link.link_type === "Text") ? _c('span', [_vm._v("("), _c('span', {
      staticClass: "text-link",
      attrs: {
        "data-id": link.text_link.ID
      }
    }, [_vm._v(_vm._s(link.link_title))]), _vm._v(")")]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77a95890!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap.vue
// module id = 476
// module chunks = 2